
export function Footer() {
    return <footer className="footer"><span>© 2022 Copyright: Christina Choriatis</span></footer>
}
